import { EventTypes } from 'redux-segment';
// Actions
const SELECTED_PROFILES_CHANGED = 'zen/historics/SELECTED_PROFILES_CHANGED';
const INCLUDE_ALL_PROFILES_CHANGED = 'zen/historics/INCLUDE_ALL_PROFILES_CHANGED';
const SELECTED_SOURCES_CHANGED = 'zen/historics/SELECTED_SOURCES_CHANGED';
const CANCEL_IMPORT = 'zen/historics/CANCEL_IMPORT';
const DATE_RANGE_CHANGED = 'zen/historics/DATE_RANGE_CHANGED';
const FETCH_ESTIMATE = 'zen/historics/FETCH_ESTIMATE';
const FETCH_ESTIMATE_BEGAN = 'zen/historics/FETCH_ESTIMATE_BEGAN';
const FETCH_ESTIMATE_SUCCEEDED = 'zen/historics/FETCH_ESTIMATE_SUCCEEDED';
const FETCH_ESTIMATE_FAILED = 'zen/historics/FETCH_ESTIMATE_FAILED';
const FETCH_IMPORT_HISTORY = 'zen/historics/FETCH_IMPORT_HISTORY';
const FETCH_IMPORT_HISTORY_SUCCEEDED = 'zen/historics/FETCH_IMPORT_HISTORY_SUCCEEDED';
const FETCH_IMPORT_HISTORY_FAILED = 'zen/historics/FETCH_IMPORT_HISTORY_FAILED';
const IMPORT_STORIES = 'zen/historics/IMPORT_STORIES';
const IMPORT_STORIES_SUCCEEDED = 'zen/historics/IMPORT_STORIES_SUCCEEDED';
const IMPORT_STORIES_FAILED = 'zen/historics/IMPORT_STORIES_FAILED';

const initialState = {
  disableImportButton: false,
  fetchingEstimate: false,
  estimate: null,
  history: [],
  fetchError: null,
  includeAllProfilesChecked: true,
  selectedProfiles: [],
  selectedSources: [],
  selectedStartDate: null,
  selectedEndDate: null
};

// Reducer
// eslint-disable-next-line complexity
const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_ESTIMATE_BEGAN:
      return {...state, estimate: null, fetchingEstimate: true, fetchError: null};
    case FETCH_ESTIMATE_SUCCEEDED:
      return {...state, estimate: action.payload.estimate, disableImportButton: !action.payload.estimate,
        fetchingEstimate: false, fetchError: null
      };
    case FETCH_ESTIMATE_FAILED:
      return {...state, estimate: null, fetchingEstimate: false, fetchError: action.payload};
    case FETCH_IMPORT_HISTORY_SUCCEEDED:
      return {...state, history: action.payload.imports, fetchError: null};
    case FETCH_IMPORT_HISTORY_FAILED:
      return {...state, history: [], fetchError: action.payload};
    case IMPORT_STORIES:
      return {...state, disableImportButton: true};
    case IMPORT_STORIES_SUCCEEDED:
      return {...state, history: [action.payload, ...state.history], estimate: null, fetchError: null,
        disableImportButton: false
      };
    case IMPORT_STORIES_FAILED:
      return {...state, estimate: null, fetchError: action.payload, disableImportButton: false};
    case SELECTED_PROFILES_CHANGED:
      return {...state, selectedProfiles: action.payload, fetchError: null};
    case INCLUDE_ALL_PROFILES_CHANGED:
      return {...state, includeAllProfilesChecked: action.payload, fetchError: null};
    case SELECTED_SOURCES_CHANGED:
      return {...state, selectedSources: action.payload, fetchError: null};
    case CANCEL_IMPORT:
      return {...state, estimate: null, fetchError: null};
    case DATE_RANGE_CHANGED:
      return {
        ...state,
        selectedStartDate: action.payload.startDate,
        selectedEndDate: action.payload.endDate,
        fetchError: null
      };
    default: return state;
  }
};

// Action Creators
const fetchEstimate = (campaignId, timezoneOffset, trackBaselineHistoric) => {
  return { type: FETCH_ESTIMATE, campaignId, timezoneOffset, trackBaselineHistoric };
};

const fetchEstimateBegan = () => {
  return { type: FETCH_ESTIMATE_BEGAN };
};

const fetchEstimateSucceeded = (payload, trackBaselineHistoric) => {
  trackBaselineHistoric.estimatedStories = payload.estimate;
  return { type: FETCH_ESTIMATE_SUCCEEDED,
    payload,
    meta: {
      analytics: {
        eventType: EventTypes.track,
        eventPayload: {
          event: 'Baseline Estimated',
          properties: trackBaselineHistoric
        }
      }
    }
  };
};

const fetchEstimateFailed = (payload) => {
  return { type: FETCH_ESTIMATE_FAILED, payload };
};

const fetchImportHistory = (campaignId) => {
  return { type: FETCH_IMPORT_HISTORY, campaignId };
};

const fetchImportHistorySucceeded = (payload) => {
  return { type: FETCH_IMPORT_HISTORY_SUCCEEDED, payload };
};

const fetchImportHistoryFailed = (payload) => {
  return { type: FETCH_IMPORT_HISTORY_FAILED, payload };
};

const importStories = (campaignId, timezoneOffset, trackBaselineHistoric) => {
  return { type: IMPORT_STORIES,
    campaignId,
    timezoneOffset,
    meta: {
      analytics: {
        eventType: EventTypes.track,
        eventPayload: {
          event: 'Baseline Started',
          properties: trackBaselineHistoric
        }
      }
    }
  };
};

const importStoriesSucceeded = (payload) => {
  return { type: IMPORT_STORIES_SUCCEEDED, payload };
};

const importStoriesFailed = (payload) => {
  return { type: IMPORT_STORIES_FAILED, payload };
};

const selectedProfilesChanged = (payload) => {
  return { type: SELECTED_PROFILES_CHANGED, payload };
};

const includeAllProfilesChanged = (payload) => {
  return { type: INCLUDE_ALL_PROFILES_CHANGED, payload };
};

const selectedSourcesChanged = (payload) => {
  return { type: SELECTED_SOURCES_CHANGED, payload };
};

const dateRangeChanged = (payload) => {
  return { type: DATE_RANGE_CHANGED, payload };
};

const cancelImport = () => {
  return { type: CANCEL_IMPORT };
};

export default reducer;
export {
  // Actions
  SELECTED_PROFILES_CHANGED,
  INCLUDE_ALL_PROFILES_CHANGED,
  SELECTED_SOURCES_CHANGED,
  FETCH_ESTIMATE,
  FETCH_ESTIMATE_BEGAN,
  FETCH_ESTIMATE_SUCCEEDED,
  FETCH_ESTIMATE_FAILED,
  FETCH_IMPORT_HISTORY,
  FETCH_IMPORT_HISTORY_SUCCEEDED,
  FETCH_IMPORT_HISTORY_FAILED,
  IMPORT_STORIES,
  IMPORT_STORIES_SUCCEEDED,
  IMPORT_STORIES_FAILED,
  CANCEL_IMPORT,
  DATE_RANGE_CHANGED,

  // Action Creators
  selectedProfilesChanged,
  includeAllProfilesChanged,
  selectedSourcesChanged,
  fetchEstimate,
  fetchEstimateBegan,
  fetchEstimateSucceeded,
  fetchEstimateFailed,
  fetchImportHistory,
  fetchImportHistorySucceeded,
  fetchImportHistoryFailed,
  importStories,
  importStoriesSucceeded,
  importStoriesFailed,
  cancelImport,
  dateRangeChanged,
};
